// extracted by mini-css-extract-plugin
export default {"account_areas":"AccountAreas_account_areas__oZOSl"};